function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgErpCardDots(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 4.59375,
    r: 0.75,
    fill: "#1A4338",
    style: {
      fill: "#1A4338",
      fill: "color(display-p3 0.1020 0.2627 0.2196)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 8.34375,
    r: 0.75,
    fill: "#1A4338",
    style: {
      fill: "#1A4338",
      fill: "color(display-p3 0.1020 0.2627 0.2196)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 12.0938,
    r: 0.75,
    fill: "#1A4338",
    style: {
      fill: "#1A4338",
      fill: "color(display-p3 0.1020 0.2627 0.2196)",
      fillOpacity: 1
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgErpCardDots);
export default __webpack_public_path__ + "static/media/erpCardDots.61a10c47de7e5afa2a21fe998006944e.svg";
export { ForwardRef as ReactComponent };